import { render, staticRenderFns } from "./CustomGroupFilter.vue?vue&type=template&id=7065e6d3&"
import script from "./CustomGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./CustomGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports